import axios from 'axios';

const instance = axios.create({
  baseURL:
    process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENV === 'development'
      ? process.env.REACT_APP_DEV_BASEURL
      : process.env.REACT_APP_BASEURL,
});

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token') || '';
    config.headers = {
      Authorization: token,
    };
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

export default instance;
